<style lang="scss" >
  .instant-search {
    position: relative;

    em {
      background-color: rgba(39, 174, 96, 0.2) !important;
      font-style: normal;
    }

    .dropdown-menu.media-list {
      max-width: none;

      .dropdown-header {
        margin-bottom: 0;
      }

      .media {
        .media-body {
          .media-heading {
            line-height: 20px;
            margin-bottom: 0;
          }
        }
      }
    }

    .dropdown-menu::-webkit-scrollbar {
      width: 5px;
    }

    .dropdown-menu::-webkit-scrollbar-thumb {
      background-color: #E0E0E0;
    }
  }
</style>

<template>
  <div class="instant-search">
    <SearchBox
      v-bind="$attrs"
      :value="query"
      @input="handleInput"
    />

    <SearchResults
      :results="results"
    />
  </div>
</template>

<script>
import SearchBox from './SearchBox';
import SearchResults from './SearchResults';

export default {
  components: {
    SearchBox,
    SearchResults,
  },

  data: () => ({
    query: '',
    results: [
      //
    ],
  }),

  methods: {
    handleInput (value) {
      this.query = value;

      if (value.length <= 3) {
        this.results = [];

        return;
      }

      this.getSearchResults(value);
    },

    async getSearchResults (value) {
      const {
        data,
      } = await this.$http.get(`/search?query=${value}`);

      this.results = data.slice(0, 5);
    },
  },
};
</script>
